import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DxReactGridBootstrap from './DxReactGridBoostrapWrapper';
import { retrieve, parseResponse, findColumns } from '../../utilities/Utility';

class AutomatTableRetrieval extends Component {
	state = {
		isLoading: true,
		rows: [],
		columns: [],
		automatColumns: []
	}

	componentWillMount() {
		let { columns } = this.props;
		columns = columns.filter((col) => {
			return col.hidden !== true;
		});
		this.setState({
			columns
		});
		this.queryRetrieve();
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.reload === true) {
			const { reloadTriggered } = this.props;
			reloadTriggered();
			this.setUnloadedState();
			this.queryRetrieve();
		} 
		if(!!nextProps.update !== false) {
			const { updateTriggered, rowIndex } = this.props;
			const row = nextProps.row;
			updateTriggered();
			switch(nextProps.update) {
				case 'changeRow':
					return this.changeRow(rowIndex, row);
				case 'addRow':
					return this.addRow(row);
			}
		}
	}

	render() {
		return <div className = 'automat_table'>
			{this.tableOrLoading()}
		</div>;
	}

	tableOrLoading = () => {
		return this.state.isLoading === true ? null : this.tableRender()
	}

	setUnloadedState = () => {
		this.setState({
			rows: [],
			isLoading: true
		})
	}

	changeRow = (rowIndex, obj) => {
		const baseRows = this.state.rows;
		const newRow = Object.assign({}, baseRows[rowIndex], this.createRowObject(obj));
		const rows = baseRows.map((row, i) => {
			if(rowIndex === i) {
				return newRow;
			}
			return row;
		});
		this.setState({
			rows
		});
	}

	addRow = (row) => {
		const newRow = this.createRowObject(row);
		const rows = [...this.state.rows, newRow];
		this.setState({
			rows
		});
	}

	createRowObject = (baseObj) => {
		const { automatColumns } = this.state;
		let rowObject = {};
		automatColumns.forEach((colObj) => {
			const colName = colObj.Name;
			if(baseObj.hasOwnProperty(colName)) {
				rowObject[colName] = baseObj[colName];
			}
		});
		return rowObject;
	}

	queryRetrieve = () => {
		const { query, params, rowTransformFn } = this.props;
		retrieve(query, params).then((res) => {
			let rows = parseResponse(res);
			if(!!rowTransformFn === true) {
				rowTransformFn(rows)
			}
			const automatColumns = findColumns(res);
			this.setState({
				rows,
				automatColumns,
				isLoading: false
			})
		});
	}

	tableRender = () => {
		const defaults = {
			rows: this.state.rows,
			columns: this.state.columns,
			expandedRowIds: this.state.expandedRowIds
		}
		const props = this.createProps();
		const conf = Object.assign(defaults, props);
		return <DxReactGridBootstrap 
			{...conf}
		/>;
	}

	createProps = () => {
		let props = {};
		const doNotCopy = ['query', 'params', 'columns'];
		Object.keys(this.props).forEach((attr) => {
			if(doNotCopy.indexOf(attr) === -1) {
				props[attr] = this.props[attr];
			}
		});
		return props;
	}
}

AutomatTableRetrieval.propTypes = {
	query: PropTypes.string.isRequired,
	params: PropTypes.object.isRequired,
	columns: PropTypes.array.isRequired,
	reload: PropTypes.bool,
	reloadTriggered: PropTypes.func,
	update: PropTypes.string
}

export default AutomatTableRetrieval;


// WEBPACK FOOTER //
// ./src/components/tableWrappers/AutomatTableRetrieval.jsx